import { render, staticRenderFns } from "./GoodsXiaofei.vue?vue&type=template&id=4d2208d4&"
import script from "./GoodsXiaofei.vue?vue&type=script&lang=js&"
export * from "./GoodsXiaofei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports